<template>
    <div class="principal container">
        <div class="col-12 container-card">
            <div class="card" style="text-align: center">
                <div class="card-body">
                    <div class="container-fluid">
                        <br>

                        <form v-if="exibirLogin" action="#" @submit.prevent="submitFormLogin" data-vv-scope="formulario">
                           
                           <div class="">
                                <h3 style="text-align: center">Seja bem-vindo!</h3>
                            </div>
                           <br>
                            <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"> <!-- Email -->
                                <label class="label" for="login">Login: </label>
                                <input type="text" v-model="login" 
                                    class="caixa-interacao" :class="{'is-invalid': errors.has('formulario.login')}" 
                                    name="login" key="login" maxlength="50" />   
                                <span v-show="errors.has('formulario.login')" class="invalid-feedback">{{ errors.first('formulario.login') }}</span>
                            </div> 

                            <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"> <!-- Senha -->      
                                <label class="label" for="senha">Senha: </label>
                                <input type="password" v-model="senha" class="caixa-interacao" :class="{'is-invalid': errors.has('formulario.senha')}" 
                                    name="senha" key="senha" maxlength="50" />
                                    <span v-show="errors.has('formulario.senha')" class="invalid-feedback">{{ errors.first('formulario.senha') }}</span>
                            </div>
                            <button style="margin-left: 30px" class="btn btn-custom primary" type="submit">Login</button>       
                        </form>

                        <div v-else>
                            <p>Seja bem-vindo!</p> 
                            <button class="btn btn-custom primary ml-lg-1" style="flex: 1;" @click="openLogout"><i></i>Sair</button>
                        </div>

                    </div>
                </div>     
            </div>


            <br>
            <form v-if="exibirCampoPesquisa" action="#"  v-on:submit.prevent="pesquisarLeads" data-vv-scope="formulario-pesquisa">
                <div class="filtro" >
                
                <label for="data-inicial">Data Inicial: </label>
                    <input class="caixa-interacao" id="data-inicial" type="date" nname="formulario-pesquisa"  v-model="dataInicio">

                <label class="label" for="data-Final">Data final: </label>
                    <input class="caixa-interacao" id="data-Final" type="date" name="formulario-pesquisa" v-model="dataFim" >

                    <input class="checkbox" type="radio" id="Lead" name="formulario-pesquisa" v-model="optLead" value="Leads" checked>
                    <label class="label" for="Lead" >Lead</label>

                    <input class="checkbox" type="radio" id="simulacoes" name="formulario-pesquisa" v-model="optSimulacao" value="Simulacao">
                    <label class="label" for="simulacoes">Simulações</label>

                    <button style="margin-left: 30px" type="submit" class="btn btn-custom primary">Consultar</button>
                    <button id="btn-excel" type="button" class="btn btn-custom primary" v-on:click="download">Excel</button>
                </div>

            </form>
         
            <br>

            <div class="card body" v-if="exibirCampoPesquisa">  

                <b-table lass="card body" 
                    id="tabelaCarteiras"
                    :colunms="colunas" 
                    :items="itemsTabela" 
                    :per-page="50"
                    :current-page="paginaTabelaRelatorio">

                    <template v-slot:cell(Nome)="row">
                        <p>{{ row.item.Nome }}</p>
                    </template>
                    <template v-slot:cell(Email)="row">
                        <p>{{ row.item.Email }}</p>
                    </template>
                    <template v-slot:cell(Telefone)="row">
                        <p>{{ row.item.Telefone }}</p>
                    </template>
                    <template v-slot:cell(Data)="row">
                        <p>{{ formatarData(row.item.data) }}</p>
                    </template>
                    <template v-slot:cell(qtdSimulacoes)="row">
                        <p>x{{ row.item.qtdSimulacoes }}x</p>
                    </template>
                </b-table>

                <b-pagination
                    v-model="paginaTabelaRelatorio"
                    :total-rows="rowsTabela"
                    :per-page="50"
                    :items="colunas"
                    aria-controls="tabelaCarteiras">            
                </b-pagination>
                    
            </div>   
        </div>
    </div>

</template>

<script>

import Vue from "vue"
import moment from 'moment';
import SimuladorService from "@/app/services/Simulador/simulador.service";
import SpinnerService from '../services/spinner.service';
import XLSX from 'xlsx';

export default {

    data() {
        return {
            login: null,
            senha: null,
            dataInicio: null,
            dataFim: null,
            exibirCampoPesquisa: false,
            exibirLogin: true,   
            itemsTabela: [],
            colunas: [            
                { key: 'Nome', label: "Nome" },
                { key: 'Email', label: "Email" },
                { key: 'Telefone', label: "Telefone" },
                { key: 'Data', label: "Data Criação" },
                { key: 'qtdSimulacoes', label: "Quantidade" },
           ],
           paginaAtual: 0,
           paginaTabelaRelatorio: null,
           optLead: '',
           optSimulacao: ''
        }
    },
    mounted() {
        this.login = "";
        this.senha = "";
    },
    methods: {
        submitFormLogin(scope) {
            this.$validator.validateAll(scope).then((result) => {
                try {
                    if (result) {
                        SimuladorService.loginRelatorio({
                            login: this.login,
                            senha: this.senha
                        }).then((retorno) => {                           
                            if (retorno.sucesso) {
                                //console.log(retorno);
                                this.exibirLogin = false;
                                this.exibirCampoPesquisa = true;                    
                            } else{
                                alert ("Email ou senha incorreta!"); 
                            }                            
                        })
                    }
                } catch (ex) {
                    //console.log(ex)
                }
            });
       },
        pesquisarLeads() {
            if (this.optLead === 'Leads') {
                this.optLead = null;
                SpinnerService.show();

                SimuladorService
                    .obterLeads({dataInicio: this.dataInicio, dataFim: this.dataFim})
                    .then((retorno) => {
                        SpinnerService.hide();   

                        this.itemsTabela = [];
                        for (let i = 0; i < retorno.leads.length; i++) {
                            this.itemsTabela.push({
                                Nome: retorno.leads[i].nome,
                                Email: retorno.leads[i].email,
                                Telefone: retorno.leads[i].telefone,
                                Data: retorno.leads[i].data,
                            });
                        }
                    });
                

            } else if (this.optSimulacao === 'Simulacao') {
                SpinnerService.show();
                
                SimuladorService
                    .obterSimulacoes ({dataInicio: this.dataInicio, dataFim: this.dataFim})
                    .then((retorno) => { 
                        SpinnerService.hide(); 

                        this.itemsTabela = [];
                        for (let i = 0; i < retorno.simulacoes.length; i++) {
                            this.itemsTabela.push({
                                Nome: retorno.simulacoes[i].nome,
                                Email: retorno.simulacoes[i].email,
                                Telefone: retorno.simulacoes[i].telefone,
                                Quantidade: retorno.simulacoes[i].qtdSimulacoes
                            });
                        }
                    });

            } else {
                alert ("Preencha todos os campos !");
            }
        },
        formatarData(data) {
            return moment(data).format("DD/MM/YYYY")
        },
        download() {
            const data = XLSX.utils.json_to_sheet(this.itemsTabela)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, data, 'Relatório')
            XLSX.writeFile(wb,'Report.xlsx')
        },
        openLogout(scope) {                  
            this.$store.commit("setLogado", false);
            document.location.reload(true)           
        }
    },
    computed: {
        formValid() {
            return this.errors.items.length == 0
                && this.login.value
                && this.senha.value;
        },
        rowsTabela() {
            return this.itemsTabela.length;
        }
    },

}

</script>

<style>
    .pikaday-header {
        max-width: 130px;
        padding-right: 0;
        z-index: 2;
        background: transparent;
    }

    .pikaday-header-icon {
        margin-left: -24px;
    }
    .caixa-interacao{
        margin-left: 10px;
    }

    .label{
        margin-left: 10px;
    }

    .botao-enviar{
        margin-left: 30px;
    }

    #btn-excel{
        margin-left: 30px;
        text-align: center;

    }

    .checkbox{
        margin-left: 10px;
    }

    .filtro{
        text-align: center;
    }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>